export default __webpack_public_path__ + "static/media/logo.992654d5.png";